import React, {Component} from 'react';
import {connect} from 'react-redux';
import {history} from '../../../../../store';
import IgniteDataTable from '../../../../common/datatable';
import ConfirmPopup from '../../../../common/confirm-popup';
import {deleteUpsellPopup} from '../../../../../actions/upsell_popups';
import PropTypes from 'prop-types';

const columns = [
  {prop: 'title', title: 'Title'},
  {prop: 'products-names', title: 'Trigger Product/s'},
];

class UpsellPopupsList extends Component {
  state = {
    delete: {
      show: false
    }
  };

  handleDelete = (result) => {
    const {dispatch} = this.props;
    const {id} = this.state.delete;
    this.setState({delete: {show: false}});
    if (result) {
      dispatch(deleteUpsellPopup(id));
    }
  };

  render() {
    const actions = [
      {
        label: 'Edit',
        permissions: {
          action: 'update',
          subjectClass: 'UpsellPopup'
        },
        callback: (row) => {
          history.push(`/admin/upsell_popups/${row.id}`);
        }
      },
      {
        label: 'Delete',
        permissions: {
          action: 'destroy',
          subjectClass: 'UpsellPopup'
        },
        callback: (row) => {
          this.setState({delete: {show: true, id: row.id}});
        }
      }
    ];

    const {upsell_popups} = this.props;
    const {delete: { show }} = this.state;

    return (
      <div>
        <IgniteDataTable
          data={upsell_popups}
          columns={columns}
          actions={actions}
          pagination={{
            sizePerPage:  20,
          }}
        />
        {
          show &&
          <ConfirmPopup
            header="DELETE UPSELL POP UP?"
            onClose={this.handleDelete}
          >
            <p>Are you sure you want to delete this upsell pop up?</p>
          </ConfirmPopup>
        }
      </div>
    )
  }
}

UpsellPopupsList.propTypes = {
  fetching: PropTypes.bool,
  fetched: PropTypes.bool,
  upsell_popups: PropTypes.array.isRequired,
};

export default connect()(UpsellPopupsList)



// WEBPACK FOOTER //
// ./src/components/admin/promotions/upsell_popups/list/upsell-popup-list.jsx